<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      @if (viewOrg) {
        <div class="row">
          <div class="col-md-6">
            <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
              <h2 >{{ViewOrgName}}</h2>
            </div>
          </div>
          <div class="col-md-6">
            <div class="button-items" style="float: right;">
              <a class="btn btn-primary btn-sm" (click)="backToOrgGrid()" role="button" pTooltip="Back to organizations list" appActionTooltip>Back</a>
            </div>
          </div>
        </div>
      }

      @if (!viewOrg) {
        <div>
          <div class="row">
            <div class="col-md-6">
              @if (!viewOrg) {
                <h2>Organization</h2>
              }
            </div>
            <div class="col-md-6">
              <div class="button-items mt-3 mb-3" style="float: right;">
                <button class="btn btn-primary btn-sm" (click)="loadOrgData(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i
                class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm clearBtn" (click)="table.clear()" pTooltip="Clear all column filters" appActionTooltip>Clear <i
                class="mdi mdi-filter-remove"></i></button>
              </div>
            </div>
          </div>
          <p-table #table [lazy]="true" [columns]="cols"
            (onLazyLoad)="loadOrgData($event)" [value]="orgData" dataKey="id" styleClass="p-datatable-projects"
            [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]"
            [loading]="loading" responsiveLayout="scroll" [paginator]="true" [autoLayout]="true"
            [totalRecords]="totalRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
            [filterDelay]="0"
            [globalFilterFields]="['clientName','projectName','statuses', 'startDate','dueDate','hours','taskname']" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width:5rem;padding:1rem !important;">
                  View/Edit
                </th>
                <th pSortableColumn="name">
                  <div>
                    Organization Name
                    <p-sortIcon field="name"></p-sortIcon>
                    <p-columnFilter matchMode="contains" type="text" [showOperator]="false"
                    [showAddButton]="false" field="name" display="menu" ></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="organizationType">
                  <div>
                    Organization Type
                    <p-sortIcon field="organizationType"></p-sortIcon>
                    <p-columnFilter matchMode="contains" type="text" [showOperator]="false"
                    [showAddButton]="false" field="organizationType" display="menu" ></p-columnFilter>
                  </div>
                </th>
                <th>
                  <div>
                    QuickBook Id
                  </div>
                </th>
                <th pSortableColumn="accountOwner">
                  <div>
                    Account Owner
                    <p-sortIcon field="accountOwner"></p-sortIcon>
                    <p-columnFilter matchMode="contains" type="text" [showOperator]="false"
                      [showAddButton]="false"
                    field="accountOwner" display="menu" ></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="createdOn">
                  <div>
                    Date Created
                    <p-sortIcon field="createdOn"></p-sortIcon>
                    <p-columnFilter type="date" field="createdOn" [showMatchModes]="true"
                      [showOperator]="false" [matchModeOptions]="matchModeOptionsDate"
                    [showAddButton]="false" display="menu" ></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="status">
                  <div>
                    Status
                    <p-sortIcon field="status"></p-sortIcon>
                    <p-columnFilter field="status" matchMode="equals" [showMatchModes]="true"
                      [showOperator]="false" [showAddButton]="false" display="menu" >
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown [ngModel]="value" [options]="statuses"
                          (onChange)="filter($event.value)" placeholder="Any">
                          <ng-template let-option pTemplate="item">
                            <span [class]="'customer-badge status-' + option">{{option.label}}</span>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </th>
                <th >
                  <div>
                    Active Projects
                    <!-- <p-sortIcon field="activePrjCount"></p-sortIcon>
                    -->
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-orgData let-columns="cols">
              <tr>
                <!-- <td>
                <p-tableCheckbox [value]="orgData"></p-tableCheckbox>
              </td> -->
              <td>
                <div>
                  <a pTooltip="View organization details" appActionTooltip class="btn btn-info btn-sm mr-2" (click)="editOrg(true, orgData)" role="button"><i
                                            class="
                                    mdi mdi-eye"></i></a>
                  <a pTooltip="Edit organization" appActionTooltip class="btn btn-warning btn-sm " (click)="editOrg( false, orgData)"
                    role="button"><i class="mdi mdi-pencil"></i></a>
                  </div>
                </td>
                @for (col of cols; track col) {
                  <td>
                    <!-- {{orgData[col.field]}} -->
                    @if (col.field=='name') {
                      <span>
                        <a href="javascript:void(0);" pTooltip="Preview organization" appActionTooltip style="cursor:pointer !important" (click)="clicked(orgData)"> {{col.data ?
                        (orgData[col.field]| date : col.format) : orgData[col.field]}}</a>
                      </span>
                    }
                    @if (col.field!='name') {
                      <span>
                        {{col.data ? (orgData[col.field]| date : col.format) : orgData[col.field]}}
                      </span>
                    }
                  </td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="4">
                  No records found
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @if (viewOrg) {
        <div>
          <p-tabView [cache]="false">
            <p-tabPanel header="Details">
              <app-view-organization [viewOrg]="viewOrg" [viewOnly]="viewOnly" [selectedRow]="selectedRow"  (closeFlag)="closeDialog($event)"></app-view-organization>
            </p-tabPanel>
            <p-tabPanel header="Matters">
              <app-matters [matterOrgFilter]="matterOrgFilter"></app-matters>
            </p-tabPanel>
            <p-tabPanel header="Projects">
              <app-projects-grid [projectOrgFilter]="projectOrgFilter"></app-projects-grid>
            </p-tabPanel>
            <!-- <p-tabPanel header="Users">
            <app-users-grid></app-users-grid>
          </p-tabPanel> -->
        </p-tabView>
      </div>
    }

  </div>
</div>
</div>

<p-dialog [resizable]="false" [draggable]="false" (onHide)="closeDialog()" [(visible)]="orgDialog"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <!-- <app-notification [errorMsg]="errorMsg"></app-notification> -->
    <app-view-organization [selectedRow]="selectedRow" [viewOnly]="viewOnly" (closeFlag)="closeDialog($event)"></app-view-organization>

    <!-- <app-view [readable]="readable" [orgDataById]= "orgDataById" [orgTypes] = "orgTypes" [invoiceTypes] = "invoiceTypes" [modal] = "modal"></app-view> -->
  </ng-template>
</p-dialog>
<!-- <ng-template #largeDataModal let-modal>
<div class="modal-header">
  <h5 class="modal-title mt-0">Organization Edit</h5>
  <button type="button" class="btn-close"
    (click)="modal.dismiss('Cross click')"
  aria-hidden="true"></button>
</div>
<div class="modal-body">
  <app-view [readable]="readable" [orgDataById]= "orgDataById" [orgTypes] = "orgTypes" [invoiceTypes] = "invoiceTypes" [modal] = "modal"></app-view>
</div>
</ng-template> -->
<!--
<ng-template #addOrgModal let-orgModal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Add Organization</h5>
    <button type="button" class="btn-close"
      (click)="orgModal.dismiss('Cross click')"
    aria-hidden="true"></button>
  </div>
  <div class="modal-body">
    <app-add-org [orgTypes] = "orgTypes" [invoiceTypes] = "invoiceTypes"></app-add-org>
  </div>
</ng-template> -->